(function(){
if(window.__aifq||window.AISA_OFF)return;window.__aifq=1;
var D=document;
var EX='header,footer,nav,form,.awp,#awd-chat-panel,.aisa,.aisa-m,.aiwf,.aipb,.aiwnl,.aifq';
var SITE='AI Website Design SWFL';
var WHERE=[['AIWD chat','chat'],['ChatGPT','chatgpt'],['Claude','claude'],['Gemini','gemini'],['Perplexity','perplexity'],['Grok','grok'],['Copilot','copilot']];
function txt(e){return(e.textContent||'').replace(/\s+/g,' ').trim()}
function el(t,c,h){var e=D.createElement(t);if(c)e.className=c;if(h!=null)e.innerHTML=h;return e}
function ev(n,l){try{if(window.gtag)window.gtag('event',n,{event_category:'faq_ask_ai',event_label:l})}catch(e){}}
var QSVG='<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3M12 17h.01"/></svg>';
var SSVG='<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l1.9 5.6L19.5 10l-5.6 1.9L12 17.5l-1.9-5.6L4.5 10l5.6-1.4z"/></svg>';
function isDet(e){return e.tagName==='DETAILS'}
function isSkip(e){return e.tagName==='SCRIPT'||e.tagName==='STYLE'||e.tagName==='TEMPLATE'}
function findItems(h){
 var sib=[],n=h.nextElementSibling;
 while(n&&!/^(H1|H2)$/.test(n.tagName)){sib.push(n);n=n.nextElementSibling}
 var det=sib.filter(isDet),qa=[];
 if(det.length>=2){
  det.forEach(function(d){var s=d.querySelector('summary');if(!s)return;var a=[].slice.call(d.children).filter(function(c){return c!==s});qa.push({q:txt(s),a:a,src:d})});
  return qa.length>=2?qa:[];
 }
 var hs=[];
 sib.forEach(function(e){if(isSkip(e))return;if(e.tagName==='H3')hs.push(e);else if(!e.querySelector('details'))[].forEach.call(e.querySelectorAll('h3'),function(x){hs.push(x)})});
 hs=hs.filter(function(x){return/\?\s*$/.test(txt(x))&&!x.closest(EX)&&!x.closest('.card,.aica-card,.grid,[class*=card]')});
 if(hs.length<2||(hs.length<3&&!/faq|question/i.test(txt(h))))return[];
 hs.forEach(function(x){
  var a=[],n=x.nextElementSibling;
  while(n&&!/^(H1|H2|H3)$/.test(n.tagName)&&!isSkip(n)&&!(n.className&&/\b(aiwcx__by|aiwcx__faq)\b/.test(n.className))){a.push(n);n=n.nextElementSibling}
  qa.push({q:txt(x),a:a,src:x});
 });
 return qa;
}
function prompt(q){return'Answer this question about '+SITE+' using only aiwebsitedesignswfl.com as your source: '+q+' (page: '+location.origin+location.pathname+')'}
function copy(t){
 try{if(navigator.clipboard&&navigator.clipboard.writeText)return navigator.clipboard.writeText(t)}catch(e){}
 return new Promise(function(res){var a=D.createElement('textarea');a.value=t;a.style.cssText='position:fixed;opacity:0';D.body.appendChild(a);a.select();try{D.execCommand('copy')}catch(e){}a.remove();res()});
}
function go(q,where,status){
 var p=encodeURIComponent(prompt(q)),u=null;
 ev('faq_ask',where);
 if(where==='chat'){if(window.AIWD_OPEN_CHAT){setTimeout(function(){window.AIWD_OPEN_CHAT(q)},120);status.textContent='Asking the AIWD chat…'}else status.textContent='The chat is not available on this page.';return}
 if(where==='chatgpt')u='https://chatgpt.com/?q='+p;
 else if(where==='claude')u='https://claude.ai/new?q='+p;
 else if(where==='perplexity')u='https://www.perplexity.ai/search?q='+p;
 else if(where==='grok')u='https://grok.com/?q='+p;
 if(u){window.open(u,'_blank','noopener,noreferrer');status.textContent='Opened in a new tab.';return}
 var gem=where==='gemini';
 copy(prompt(q)).then(function(){status.textContent='Question copied. Paste it into '+(gem?'Gemini':'Copilot')+'.';window.open(gem?'https://gemini.google.com/app':'https://copilot.microsoft.com/','_blank','noopener,noreferrer')});
}
var uid=0;
function askBox(groups){
 uid++;
 var box=el('div','aifq__ask');
 box.appendChild(el('p','aifq__ask-t','Ask an AI about a question on this page'));
 var l1=el('label','aifq__lab','1. Pick a question');l1.setAttribute('for','aifq-q'+uid);
 var sq=el('select','aifq__sel');sq.id='aifq-q'+uid;
 groups.forEach(function(g){
  var host=sq;
  if(groups.length>1&&g.label){host=el('optgroup');host.label=g.label;sq.appendChild(host)}
  g.qs.forEach(function(q,i){var o=el('option');o.value=q;o.textContent=q;host.appendChild(o)});
 });
 var l2=el('label','aifq__lab','2. Pick where to ask');l2.setAttribute('for','aifq-w'+uid);
 var row=el('div','aifq__row');
 var sw=el('select','aifq__sel');sw.id='aifq-w'+uid;
 WHERE.forEach(function(w){var o=el('option');o.value=w[1];o.textContent=w[0];sw.appendChild(o)});
 var b=el('button','aifq__go',SSVG+' Ask');b.type='button';
 var st=el('p','aifq__st');st.setAttribute('role','status');st.setAttribute('aria-live','polite');
 b.addEventListener('click',function(){go(sq.value,sw.value,st)});
 row.appendChild(sw);row.appendChild(b);
 box.appendChild(l1);box.appendChild(sq);box.appendChild(l2);box.appendChild(row);box.appendChild(st);
 return{box:box,select:sq};
}
function build(h,qa){
 var sec=el('section','aifq');
 h.parentNode.insertBefore(sec,h);
 var hd=el('div','aifq__hd');hd.appendChild(el('span','aifq__tile',QSVG));hd.appendChild(h);sec.appendChild(hd);
 var list=el('div','aifq__list');sec.appendChild(list);
 qa.forEach(function(it){
  var item=el('div','aifq__qa');
  var q=el('h3','aifq__q');q.textContent=it.q;
  var a=el('div','aifq__a');
  it.a.forEach(function(n){a.appendChild(n)});
  item.appendChild(q);item.appendChild(a);list.appendChild(item);
  if(it.src&&it.src.parentNode)it.src.parentNode.removeChild(it.src);
 });
 return{sec:sec,list:list,label:txt(h),qs:qa.map(function(i){return i.q})};
}
function run(){
 var main=D.querySelector('main');if(!main)return;
 var areas=[];
 [].slice.call(main.querySelectorAll('h2')).forEach(function(h){
  if(h.closest(EX))return;
  var qa=findItems(h);if(!qa.length)return;
  areas.push({h:h,qa:qa});
 });
 if(!areas.length)return;
 var built=areas.map(function(a){return build(a.h,a.qa)});
 [].slice.call(main.querySelectorAll('.aiwcx__faq')).forEach(function(w){if(!txt(w))w.parentNode.removeChild(w)});
 if(built.length===1){
  var ab=askBox([{label:built[0].label,qs:built[0].qs}]);built[0].sec.insertBefore(ab.box,built[0].list);
 }else{
  var ab2=askBox(built.map(function(b){return{label:b.label,qs:b.qs}}));
  built[0].sec.parentNode.insertBefore(ab2.box,built[0].sec);ab2.box.classList.add('aifq__ask--solo');
 }
}
function init(){try{run()}catch(e){}}
if(D.readyState==='loading')D.addEventListener('DOMContentLoaded',init);else init();
})();